import { createBrowserRouter } from 'react-router-dom';
import App from './App';

// https://github.com/remix-run/react-router/issues/9422#issuecomment-1302564759

export const router = createBrowserRouter([
  // match everything with "*"
  { path: '*', element: <App /> },
]);
